package com.tixforgigs.common.core.extensions

import com.tixforgigs.apax.models.Flavor
import com.tixforgigs.common.core.util.SentryUtil.captureException
import com.tixforgigs.common.http.HttpClient.FLAVOR

inline fun <T, R> T.tryCatchSentry(captureException: Boolean = true, block: T.() -> R): Result<R> = runCatching {
  block()
}.onFailure {
  if (captureException) {
    if (FLAVOR != Flavor.PROD) {
      it.printStackTrace()
    }
    captureException(it)
  }
}
